import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { PageWithLayout } from '../containers/page';


class ContactsPage extends Component {
    constructor(props) {
        super(props);

        this.registerSocketIOEvents = this.registerSocketIOEvents.bind(this);
        this.handleDeletePrompt = this.handleDeletePrompt.bind(this);
        this.state = {
            contacts: []
        };
    }


    componentDidMount() {
        this.props.handleLoader(true);

        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }


    }

    componentDidUpdate(prevProps) {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }
    }

    registerSocketIOEvents() {
        if (this.state._registeredEvents)
            return;

        this.setState({
            _registeredEvents: true
        });



        this.props.socketIOClient.on('contacts', (data) => {
            this.props.handleLoader(null);

            console.log(data);
            this.setState({
                contacts: data
            });
        });


        this.props.socketIOClient.emit('contacts', {});
    }


    componentWillUnmount() {
        if (!this.props.socketIOClient) return;
        this.props.socketIOClient.removeAllListeners("contacts");
    }

    handleDeletePrompt(answer, val) {
        console.log(val);
        if (answer) {
            this.props.socketIOClient.emit('deleteContact', { contact: val });
            this.props.openDeletePrompt(null, null);

        } else {
            this.props.openDeletePrompt(null, null);
        }
    }

    render() {

        return (
            <div className="content">
                {

                    (!this.props.uData && !localStorage.uData) && <Redirect to='/login' />

                }
                <div className="panel panel-list">
                    <div>

                        <div className="title">
                            <h1>{this.props.translate('Contacts')}</h1>


                            <h6>{this.props.translate('List of contacts')}</h6>



                        </div>


                        <div className="table">
                            <table>
                                <tr className="text-row">
                                    <th>{this.props.translate('Name')}</th>
                                    <th>{this.props.translate('Email')}</th>
                                    <th>{this.props.translate('Phone')}</th>
                                    <th>{this.props.translate('Subject')}</th>
                                    <th>{this.props.translate('Message')}</th>
                                    <th className="action-head">{this.props.translate('Action')}</th>

                                </tr>

                                {
                                    this.state.contacts.map((contact) => {
                                        return (
                                            <tr className="text-row">
                                                <td>{contact.firstname + " " + contact.lastname}</td>
                                                <td>{contact.email}</td>
                                                <td>{contact.phone}</td>
                                                <td>{contact.subject}</td>
                                                <td>{contact.message}</td>
                                                <td className="action">
                                                    <button className="button" onClick={() => this.props.openDeletePrompt(contact._id, this.handleDeletePrompt)}><i className="mdi mdi-delete"></i> </button>
                                                </td>
                                            </tr>


                                        )
                                    }
                                    )}

                            </table>

                        </div>


                    </div>

                </div>


            </div>
        );
    }
}

export default PageWithLayout(ContactsPage);


// WEBPACK FOOTER //
// ./src/views/contactsPage.js